import useItineraryUtils from '@/src/hooks/itinerary/useItineraryUtils'
import { DeviceType } from '@/src/types/deviceType'
import { ItineraryStepNumberType } from '@/src/types/itinerary'
import HeaderBlock from './headerBlock'

const HeaderBlockWrapper = ({
    step,
    isStepActive,
    stepTitle,
    deviceType
}: {
    step: ItineraryStepNumberType
    isStepActive: boolean
    stepTitle: string
    deviceType?: DeviceType
}) => {
    const { getIsStepCompleted } = useItineraryUtils()
    const isStepCompleted = getIsStepCompleted(step)

    return (
        <HeaderBlock
            step={step}
            isStepCompleted={isStepCompleted}
            isStepActive={isStepActive}
            stepTitle={stepTitle}
            deviceType={deviceType}
        />
    )
}

export default HeaderBlockWrapper
